import React from 'react';

import {LinkProps} from "../../../../core/components/link/link-composer";
import {RightArrow} from "../../../../core/icons/arrows/right-arrow";
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetNavigationButton} from "./entity-scores-widget.navigation-button";
import styles from "../../styles/entity-scores-widget.module.scss";
import {ENTITY_SCORES} from "../../entity-scores-widget.consts";
import {
  EntityContainerHashParamsModel
} from "../../../../core/components/router/models/entity-container-hash-params-model";

export class EntityScoresWidgetNavigationButtonsFixtureProps extends BaseProps {
}

export const EntityScoresWidgetNavigationButtonsFixture = ({controller, onFilterChange}: EntityScoresWidgetNavigationButtonsFixtureProps) => {
  const {terms: {WEB_FIXTURES_BUTTON},state} = controller;
  const {entity} = state;

  const buttonProps: LinkProps = {
    controller,
    linkParams: new EntityContainerHashParamsModel({fixtures: ENTITY_SCORES.URL_FILTERS.fixtures}),
    filterType: ENTITY_SCORES.ANALYTICS.FILTERS.fixtures,
    onClick: onFilterChange ? () => onFilterChange(ENTITY_SCORES.FILTERS_INDEX.fixtures, true) : null
  }

  return (
    <EntityScoresWidgetNavigationButton {...buttonProps}>
      {WEB_FIXTURES_BUTTON.format({'ENTITY_NAME': entity?.name})}
      <RightArrow className={classNames(styles.navigation_arrow)}/>
    </EntityScoresWidgetNavigationButton>
  )
}
